import { useTranslation } from "react-i18next";
const InfoInput = (props) => {
    const { t } = useTranslation()
    return (
        <div class="mb-3">
            <label for="infoBoxText" class="form-label"><b>{t("infoBoxText")}</b></label> <br /><i>boş ise 1 ader boşluk giriniz.</i>
            <textarea class="form-control" id="infoBoxText" defaultValue={"Konu anlatım videosunu tekrar izleyebilirsin. Sonra, soruyu yeniden cevaplamalısın."} required />
        </div>
    );
};

export default InfoInput;